// src/components/RouteFlows.js

import { useEffect, useState } from "react";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { routeFlowsData } from "./routeFlowsData";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { minHeight } from "@mui/system";

// Register Chart.js components + DataLabels plugin
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const routeFlowsSchema = [
  {
    id: 1,
    name: "Elefsina to Athens International Airport",
    endPoint: "/pg/latest_route_flows_to_airport",
    computeValue: (entry) => entry.value_in ?? 0,
  },
  {
    id: 2,
    name: "Athens International Airport to Elefsina",
    endPoint: "/pg/latest_route_flows_to_eleusina",
    computeValue: (entry) => entry.value_out ?? 0,
  },
  // {
  //   id: 3,
  //   name: "Olgas",
  //   endPoint: "/latest_route_flows_olgas_transformed",
  //   computeValue: (entry) => entry.value_in ?? 0,
  // },
  // {
  //   id: 4,
  //   name: "Nikis",
  //   endPoint: "/latest_route_flows_nikis_transformed",
  //   computeValue: (entry) => entry.value_out ?? 0,
  // },
];

function RouteFlows() {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);

    const results = await Promise.all(
      routeFlowsSchema.map((endpoint) => routeFlowsData(endpoint))
    );

    console.log("re")
    const filtered = results.filter((c) => c !== null);

    // Determine global max Y for uniform scaling
    let maxY = 0;
    filtered.forEach((chart) =>
      chart.data.datasets.forEach((ds) => {
        const localMax = Math.max(...ds.data);
        if (localMax > maxY) maxY = localMax;
      })
    );

    // Inject maxY into each chart’s options
    const updated = filtered.map((chart) => ({
      ...chart,
      options: {
        ...chart.options,
        plugins: {
          ...chart.options.plugins,
          // merge in your DataLabels config here:
          datalabels: {
            anchor: "end",
            align: "end",
            offset: -4,
            formatter: (v) => v,
            font: { size: 12 },
            color: "#888a91",
          },
        },
        scales: {
          ...chart.options.scales,
          y: {
            ...chart.options.scales.y,
            min: 0,
            max: maxY,
            beginAtZero: true,
          },
        },
      },
    }));

    setChartData(updated);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <Card>
        <MDBox p={3} lineHeight={1}>
          <MDTypography variant="h5" fontWeight>
            Route Flows
          </MDTypography>
        </MDBox>
      </Card>

      {loading ? (
        <MDBox p={3} textAlign="center">
          <MDTypography variant="h6">Loading...</MDTypography>
        </MDBox>
      ) : chartData.length > 0 ? (
        chartData.map((chart, i) => (
          <Card
            key={i}
            sx={{
              marginTop: "0.5rem",
              padding: "0.5rem",
              minHeight: "350px",
              width: "100%",
            }}
          >
            <MDBox sx={{ padding: "0.5rem", minHeight: "350px" }}>
              <Bar data={chart.data} options={chart.options} plugins={[ChartDataLabels]} />
            </MDBox>
          </Card>
        ))
      ) : (
        <MDBox p={3} textAlign="center">
          <MDTypography variant="h6">No Data Available</MDTypography>
        </MDBox>
      )}
    </DashboardLayout>
  );
}

export default RouteFlows;
